module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/third-party.507bfe40.svg";